import FeeScheduleCategoryCommand from "marketplace/teams/fee-schedules/_api/commands/fee-schedule-category-command";
import FeeSchedule from "marketplace/teams/fee-schedules/fee-schedule";

export default class FeeScheduleCommand {
  name: string;
  tags: string[];
  categories: FeeScheduleCategoryCommand[];

  constructor(feeSchedule: FeeSchedule) {
    this.name = feeSchedule.name;
    this.tags = feeSchedule.tags.map(tag => tag.value) ?? [];
    this.categories =
      feeSchedule.categories?.map(
        (category) => new FeeScheduleCategoryCommand(category)
      ) ?? [];
  }
}
